import { render } from "./EmailOutbox.vue?vue&type=template&id=a8a1c4e0&scoped=true"
import script from "./EmailOutbox.vue?vue&type=script&lang=js"
export * from "./EmailOutbox.vue?vue&type=script&lang=js"

import "./EmailOutbox.vue?vue&type=style&index=0&id=a8a1c4e0&scoped=true&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8a1c4e0"]])

export default __exports__